import { useEffect, useState, useMemo } from 'react';
import { Event } from 'nostr-tools';
import { getNostrPool } from '../lib/nostrPool';
import { RELAYS } from '../config/constants';
import { useAdmin } from '../contexts/AdminContext';

export const useRoomMessages = (roomId: string) => {
    const [messages, setMessages] = useState<Event[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const pool = getNostrPool();
    const { settings } = useAdmin();

    const currentRelays = useMemo(() => {
        return [...new Set([...RELAYS, ...settings.customRelays])];
    }, [settings.customRelays]);

    useEffect(() => {
        if (!roomId) return;

        setIsLoading(true);
        setMessages([]);

        const filter = {
            kinds: [9],
            '#h': [roomId],
            limit: 50
        };

        const sub = pool.subscribeMany(currentRelays, filter, {
            onevent(event: Event) {
                if (settings.mutedUsers.includes(event.pubkey)) return;

                setMessages((prev) => {
                    const exists = prev.some((e) => e.id === event.id);
                    if (exists) return prev;
                    return [...prev, event].sort((a, b) => a.created_at - b.created_at);
                });
            },
            oneose() {
                setIsLoading(false);
            },
        });

        return () => {
            sub.close();
        };
    }, [roomId, settings.mutedUsers, currentRelays]);

    return { messages, isLoading };
};
